import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

// 第二屏：真人级的革命性交互
export default function Screen2() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen2-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-ai-scroll',
    enableResizeDetection: true
  });
  return (
    <section className={styles['screen2-cover']} ref={rootRef}>
      <div className={styles['screen2-wrap']}>
        {/* 标题 */}
        <div className={styles['screen2-title-wrap']}>
          <h2 className={styles['screen2-title']}>真人级的革命性交互</h2>
          <div className={styles['screen2-title-desc']}>自研数字人及语音技术，构造真人级别的AI互动体验</div>
        </div>

        {/* 三列卡片 */}
        <div className={styles['screen2-flex']}>
          <div className={styles['screen2-flex-inner']}>
            {/* 卡片1：高并发 */}
            <div
              className={`${styles['screen2-card']} ${styles['screen2-card-1']}`}
            >
              <div className={styles['screen2-text']}>
                <div className={styles['screen2-title-sm']}>注意力集中，全程不走神</div>
                <div className={styles['screen2-sub-sm']}>短时高频互动，调配学习者注意力，将专注力与思考力从 “分开动” 到 “一起动”。</div>
              </div>
            </div>

            {/* 卡片2：低延时 */}
            <div
              className={`${styles['screen2-card']} ${styles['screen2-card-2']}`}
            >
              <div className={styles['screen2-text']}>
                <div className={styles['screen2-title-sm']}>因材施教，学有所成</div>
                <div className={styles['screen2-sub-sm']}>过程检测掌握情况，随时调整学习难度，将难度与方法精准结合，支撑多元学习场景。</div>
              </div>
            </div>

            {/* 卡片3：全适配 */}
            <div
              className={`${styles['screen2-card']} ${styles['screen2-card-3']}`}
            >
              <div className={styles['screen2-text']}>
                <div className={styles['screen2-title-sm']}>及时鼓励，激发动力</div>
                <div className={styles['screen2-sub-sm']}>创造及时互动反馈，让“理解我，鼓励我”成为学习自信的根本来源，激发学习潜能，强化学习动力。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
